import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { listAttributes } from '../actions/attributeActions';
import { addToCart, removeFromCart, savePaymentMethod, updateQty } from '../actions/cartActions';
import { getNotificationsUser } from '../actions/notificationActions';
import { createOrder, detailsOrder, editOrder } from '../actions/orderActions';
import { listProducts } from '../actions/productActions';
import { ToolBar } from '../components/ToolBar';
import { ORDER_CREATE_RESET, ORDER_EDIT_RESET } from '../constants/orderConstants';

export const CartScreen = (props) => {

    const params = useParams();

    const productId = params.id;

    const navigate = useNavigate();

    const [searchParms] = useSearchParams();
    const qty = Number(searchParms.get("qty"));


    const cart = useSelector(state => state.cart);
    const { cartItems } = cart;

    const attributeList = useSelector((state) => state.attributeList);
    const { attributes } = attributeList;

    const productList = useSelector((state) => state.productList);
    const { products } = productList;

    const orderCreate = useSelector((state) => state.orderCreate);
    const {success, order} = orderCreate;

    const orderEdit = useSelector((state) => state.orderEdit)

    const orderDetails = useSelector(state => state.orderDetails);

    const [isSubmited, setIsSubmited] = useState(false)
    const [removed, setRemoved] = useState(false)

    const dispatch = useDispatch();

    useEffect(() => {
        if (productId) {
            dispatch(addToCart(productId, qty))
        }
    }, [dispatch, productId, qty])

    useEffect(() => {
        dispatch(listAttributes())
        dispatch(listProducts());
        dispatch(getNotificationsUser());
    }, [dispatch])

    useEffect(() => {
        if (cart.paymentMethod && localStorage.getItem('orderId') === null) {
            const toPrice = (num) => Number(num.toFixed(2)); // 5.123 => "5.12" => 5.12
  
            let totalPrice = 0
            let totalTaxes = 0

            cart.cartItems.forEach(item => {
                let priceWithoutTaxes = item.price / (1 + item.iva / 100)
                let taxesPrice = item.price - priceWithoutTaxes

                totalPrice += item.qty * priceWithoutTaxes
                totalTaxes += item.qty * taxesPrice
            });

            // Precio total de los artículos
            cart.itemsPrice = toPrice(totalPrice)
            //Precio total del iva de los artículos
            cart.taxPrice = toPrice(totalTaxes)
            // Coste de envío
            cart.shippingPrice = 0;
            // Total: precio de los articulos + coste de envío + impuestos
            cart.totalPrice = cart.itemsPrice + cart.shippingPrice + cart.taxPrice;
            dispatch(createOrder({...cart, orderItems: cart.cartItems}))
            // cart.cartItems.forEach(item => {
            //     let fields = {attr: false, stock: item.qty, value: null}
            //     if (item.attributes.length > 0) {
            //         fields.attr = true
            //         fields.value = item.attributes[0].value
            //     }
            //     dispatch(updateStock(fields, item.product))
            // });
        }
    }, [cart, dispatch, navigate])

    useEffect(() => {
        if(success && isSubmited === false && !removed) {
            dispatch({type: ORDER_CREATE_RESET});
            navigate(`/order/${order._id}`);
        }
      }, [dispatch, order, success, navigate, isSubmited, removed])

      useEffect(() => {
          if (orderDetails?.order && isSubmited && !removed) {
            if (cart.cartItems !== orderDetails.order.orderItems) {
                const toPrice = (num) => Number(num.toFixed(2)); // 5.123 => "5.12" => 5.12

                let totalPrice = 0
                let totalTaxes = 0

                cart.cartItems.forEach(item => {
                    let priceWithoutTaxes = item.price / (1 + item.iva / 100)
                    let taxesPrice = item.price - priceWithoutTaxes

                    totalPrice += item.qty * priceWithoutTaxes
                    totalTaxes += item.qty * taxesPrice
                });

                // Precio total de los artículos
                cart.itemsPrice = toPrice(totalPrice)
                //Precio total del iva de los artículos
                cart.taxPrice = toPrice(totalTaxes)
                // Coste de envío
                cart.shippingPrice = 0;
                // Total: precio de los articulos + coste de envío + impuestos
                cart.totalPrice = cart.itemsPrice + cart.shippingPrice + cart.taxPrice;
                dispatch(editOrder(localStorage.getItem('orderId'), {...cart, orderItems: cart.cartItems}))
            }
            setIsSubmited(false)
          }
      }, [orderDetails.order, cart, navigate, dispatch, isSubmited, removed])

      useEffect(() => {
          if (orderEdit.success && !removed) {
              dispatch({type: ORDER_EDIT_RESET})
              navigate(`/order/${localStorage.getItem('orderId')}`);
          }
      }, [orderEdit, navigate, dispatch, removed])

    const removeFromCartHandler  = (index) => {
        setRemoved(true)
        dispatch(removeFromCart(index))
    }


    const checkoutHandler = () => {
        if (localStorage.getItem('orderId') === null) {
            dispatch(savePaymentMethod('Tarjeta crédito/débito'));
        } else {
            setIsSubmited(true)
            dispatch(detailsOrder(localStorage.getItem('orderId')))
        }
    }

    const columns = [
        {
            name: 'Producto',
            cell: row =>
                <div className="d-flex align-items-center flex-md-row flex-column py-3">
                    <Link to={`/product/${row.product}`} className="symbol symbol-50px">
                        <span className="symbol-label" style={{ backgroundImage: `url(${row.image})` }}></span>
                    </Link>
                    <div className="ms-5">
                        <Link to={`/product/${row.product}`} className="text-gray-800 text-hover-primary fs-5 fw-bolder" data-kt-ecommerce-product-filter="product_name">
                            {row.name}
                            {row.attributes?.length > 0
                                ?
                                `, ${attributes?.find(att => att._id === row.attributes[0].attribute)?.name}: ${row.attributes[0].value}`
                                :
                                ''}
                        </Link>
                    </div>
                </div>,
            selector: (row) => row.name,
        },
        {
            name: "Cantidad",
            selector: (row) => row.qty,
            cell: (row) =>
                <span className="fw-bolder ms-3">
                    <select value={row.qty} onChange={e => dispatch(updateQty(row.product, Number(e.target.value)))}>
                        {
                            products?.find(prod => prod._id === row.product)?.countInStock
                                ?
                                [...Array(products?.find(prod => prod._id === row.product)?.countInStock).keys()].map((x) => (
                                    <option key={x + 1} value={x + 1}>{x + 1}</option>
                                ))
                                :
                                [...Array(products?.find(prod => prod._id === row.product)?.attributes.find(attr => attr.value === row.attributes[0]?.value)?.stock).keys()].map((x) => (
                                    <option key={x + 1} value={x + 1}>{x + 1}</option>
                                ))
                        }
                    </select>
                </span>,
        },
        {
            name: "Precio",
            cell: row => <span>{row.price} €</span>,
            selector: (row) => row.price,
            right: true
        },
        {
            name: "Acciones",
            cell: (row, index) =>
                <div className="dropdown dropup">
                    <button className="btn btn-sm btn-light btn-active-light-primary" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                        Acciones
                        <span className="svg-icon svg-icon-5 m-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black" />
                            </svg>
                        </span>
                    </button>
                    <ul className="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4" aria-labelledby="dropdownMenuButton1">
                        <li className="menu-item px-3"><button className="dropdown-item menu-link px-3" row={index} onClick={() => removeFromCartHandler(index)} >Eliminar</button></li>
                    </ul>
                </div>,
            center: true,
        }
    ];


    const customStyles = {
        rows: {
            style: {
                minHeight: '72px', // override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
            },
        },
    };

    return (
        <>

            <ToolBar titulo={"Mi cesta"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Carrito", enlace: "#" }]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                        <div className="col-xl-8">
                            <div className="card card-flush">
                                <div className="card-body pt-0">
                                    {/* <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_ecommerce_products_table">            
                            <thead>                
                                <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">                                
                                    <th className="min-w-200px">Producto</th>
                                    <th className="text-end min-w-70px">Cantidad</th>
                                    <th className="text-end min-w-100px">Precio</th>
                                    <th className="text-end min-w-70px">Acciones</th>
                                </tr>                
                            </thead>                        
                            <tbody className="fw-bold text-gray-600">
                                {cartItems.length === 0 ? 
                                <tr>
                                    <td>Carrito vacío</td>
                                </tr> : 
                                <>
                                    {cartItems.map((item, index) => (                
                                    <tr key={item.product + index}>                    
                                                                               
                                        <td>
                                            <div className="d-flex align-items-center">                            
                                                <Link to={`/product/${item.product}`} className="symbol symbol-50px">
                                                    <span className="symbol-label" style={{ backgroundImage: `url(${item.image})` }}></span>
                                                </Link>                            
                                                <div className="ms-5">   
                                                    <Link to={`/product/${item.product}`} className="text-gray-800 text-hover-primary fs-5 fw-bolder" data-kt-ecommerce-product-filter="product_name">
                                                    {item.name}
                                                    {item.attributes?.length > 0
                                                    ?
                                                    `, ${attributes?.find(att => att._id === item.attributes[0].attribute)?.name}: ${item.attributes[0].value}`
                                                    :
                                                    ''}
                                                    </Link>                             
                                                    
                                                </div>
                                            </div>
                                        </td>                                                                                                   
                                        <td className="text-end pe-0" data-order="41">
                                            <span className="fw-bolder ms-3">
                                                <select value={item.qty} onChange={e => dispatch(updateQty(item.product, Number(e.target.value)))}>
                                                    {
                                                        products?.find(prod => prod._id === item.product)?.countInStock
                                                        ?
                                                        [...Array(products?.find(prod => prod._id === item.product)?.countInStock).keys()].map( (x) => (
                                                            <option key={x+1} value={x + 1}>{x + 1}</option>
                                                        ))
                                                        :
                                                        [...Array(products?.find(prod => prod._id === item.product)?.attributes.find(attr => attr.value === item.attributes[0]?.value)?.stock).keys()].map( (x) => (
                                                            <option key={x+1} value={x + 1}>{x + 1}</option>
                                                        ))
                                                    }
                                                </select>
                                            </span>
                                        </td>                                        
                                        <td className="text-end pe-0">
                                            <span className="fw-bolder text-dark">{item.price} €</span>
                                        </td>                                                                                                                
                                        <td className="text-end pe-0">                        
                                        <button type="button" className="btn btn-primary btn-block" onClick={ () => removeFromCartHandler(index)}>Eliminar</button>
                                        </td>                                                                               
                                    </tr> 
                                    ))}
                                </>
                                }                                           
                            </tbody>            
                        </table>         */}
                                    <div className="col-12 pt-5">
                                        <DataTable
                                            noDataComponent="Carrito vacío"
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            data={cartItems}
                                            columns={columns}
                                            customStyles={customStyles}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card h-md-100">
                                <div className="card-body d-flex flex-column">
                                    <h2>
                                        Subtotal ({cartItems.reduce((a, c) => a + c.qty, 0)} artículos) : <span>{cartItems.reduce((a, c) => a + c.price * c.qty, 0).toFixed(2)} €</span>
                                    </h2>
                                    <button type="button" onClick={checkoutHandler} className="btn btn-primary btn-block" disabled={cartItems.length === 0}>Finalizar compra</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}